let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9ygQy")).then(() => parcelRequire('il5Of'));